const getFeaturesUnderParentKey = (obj = {}, item, featuresUnderParentKey) => {
  if (obj[item]) {
    Object.assign(featuresUnderParentKey, obj[item]);
  }

  return Object.values(obj).map(
    value =>
      !value?.roles &&
      getFeaturesUnderParentKey(value, item, featuresUnderParentKey)
  );
};

export const hasARoleWithPermission = (userRoles, featuresRoles) =>
  userRoles
    ?.map(role => role?.name)
    ?.map(userRole => featuresRoles?.[userRole]?.length > 0)
    ?.flat()
    ?.includes(true);

export const hasASubAppWithReadPermission = (appName, user) =>
  appName
    ? Object.values(appName)
        ?.map(app =>
          app?.roles
            ? hasARoleWithPermission(user?.role, app?.roles)
            : hasASubAppWithReadPermission(app, user)
        )
        .includes(true)
    : false;

export const getPermissions = (features, userRoles) => [
  ...new Set(
    userRoles
      ?.map(role => role?.name)
      ?.map(roleName => features?.roles?.[roleName])
      ?.flat()
  ),
];

export const getPermissibleFeatures = params =>
  params.links.reduce((acc, link) => {
    if (link?.items) {
      const filteredSidebarLinks = getPermissibleFeatures({
        links: link.items,
        parentKey: link.label,
        app: params.app,
        features: params.features,
        user: params.user,
      });

      return filteredSidebarLinks.length !== 0
        ? [...acc, { ...link, items: filteredSidebarLinks }]
        : [...acc];
    }
    const featuresUnderParentKey = {};

    if (params.parentKey) {
      getFeaturesUnderParentKey(
        params.features?.[params.app],
        params.parentKey,
        featuresUnderParentKey
      );
    } else {
      Object.assign(featuresUnderParentKey, params.features?.[params.app]);
    }

    if (
      (!link?.items &&
        hasARoleWithPermission(
          params.user?.role,
          featuresUnderParentKey?.[link.label]?.roles
        )) ||
      (link.items &&
        Object.keys(params.features?.data_management?.[link.label] ?? {})
          ?.length)
    ) {
      return acc ? [...acc, link] : [link];
    }

    return [...acc];
  }, []);
